import { apiAuth, apiResponseType } from "./index";

/**
 * Tipo do valor de uma configuração. Define como o `value` (sempre texto) deve
 * ser interpretado e qual campo de edição a tela do admin deve renderizar.
 */
export type SettingValueType =
  | "boolean"
  | "integer"
  | "decimal"
  | "string"
  | "text"
  | "date"
  | "datetime"
  | "json"
  | "date_range"
  | "minutes"
  | "hours"
  | "days"
  | "weeks"
  | "months"
  | "years";

export interface Setting {
  uuid: string;
  name: string;
  key: string;
  value_type: SettingValueType;
  value: string | null;
  default_value: string | null;
  is_active: boolean;
  has_value: boolean;
}

/**
 * Configurações públicas do tenant. Chaves internas nunca vêm nesta resposta.
 */
export const getSettings = (): apiResponseType => apiAuth.get("settings");

export const showSetting = (uuid: string): apiResponseType =>
  apiAuth.get(`settings/${uuid}/show`);

export const updateSetting = (
  uuid: string,
  data: { value?: string | null; is_active?: boolean }
): apiResponseType => apiAuth.put(`settings/${uuid}/update`, data);
